import { useEffect, useState } from "react";
import { getApi, postApi } from "../../api/call.api";
import { urlApi } from "../../api/url.api";
import { PROFILE } from "../../statics/localStorage";
import { loadingHide, loadingShow } from "../../loadingUi/loading.controller";
import { uploadImage } from "../../api/api.global";
import { accessCheck } from "../../utils/accessCheck";
import { accessKeys } from "../../statics/accessKeys";
import { CHAT_DOMAIN, CHAT_DOMAIN_PROFILE } from "../../api/static.data.pnp";
import { toast } from "sonner";

const OrganizationForm = () => {
    const [name, setName] = useState("");
    const [website, setWebsite] = useState("");
    const [logo, setLogo] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [errors, setErrors] = useState({});

    const profileData = PROFILE();

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogo(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const getOrgDetails = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getOrganizationDetailsForChat + profileData?.defaultOrganizationId);
        loadingHide();
        if (resp?.responseCode === 200) {
            setLogoPreview(resp?.data?.organizationIcon);
            setName(resp?.data?.organizationName);
            setWebsite(resp?.data?.organizationWebsite);
        } else {
            setLogoPreview(null);
            setName("");
            setWebsite("");
        }
    }

    useEffect(() => {
        getOrgDetails()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        if (!name.trim()) newErrors.name = "Organization name is required.";
        if (!website.trim()) newErrors.website = "Website is required.";
        setErrors(newErrors);
        loadingShow();
        let postData = {
            "organizationId": profileData?.defaultOrganizationId,
            "name": name,
            "organizationIcon": logoPreview ? logoPreview : await uploadImage(logo, 'advy-organization'),
            "website": website
        }
        let resp = await postApi(postData, urlApi.updateOrganizationDetailsForChat);
        loadingHide();
        if (resp?.responseCode === 200) {
            toast.success(resp?.message);
            if (accessCheck(accessKeys?.createAndUpdateChatSession)) {
                window.location.replace(CHAT_DOMAIN);
            } else {
                window.location.replace(CHAT_DOMAIN_PROFILE)
            }
            return;
        } else {
            toast.error(resp?.message);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
            <form
                onSubmit={handleSubmit}
                className="bg-white w-full max-w-xl rounded-2xl shadow-md border border-gray-200 p-8 space-y-6"
            >
                <div className="text-center">
                    <h2 className="text-2xl font-semibold text-gray-800">
                        Organization Details
                    </h2>
                    <p className="text-gray-500 text-sm mt-1">
                        Please fill out the required information to continue.
                    </p>
                </div>

                {/* Organization Name */}
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">
                        Organization Name <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="e.g. ABC Pvt Ltd"
                        className={`w-full px-4 py-2.5 text-sm rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${errors.name ? "border-red-400" : "border-gray-300"
                            }`}
                    />
                    {errors.name && (
                        <p className="text-red-500 text-xs">{errors.name}</p>
                    )}
                </div>

                {/* Website */}
                <div className="space-y-1">
                    <label className="block text-sm font-medium text-gray-700">
                        Website <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="url"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                        placeholder="https://example.com"
                        className={`w-full px-4 py-2.5 text-sm rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 transition ${errors.website ? "border-red-400" : "border-gray-300"
                            }`}
                    />
                    {errors.website && (
                        <p className="text-red-500 text-xs">{errors.website}</p>
                    )}
                </div>

                {/* Logo Upload */}
                <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                        Organization Logo
                    </label>
                    <label className="cursor-pointer flex items-center justify-center h-40 border-2 border-dashed border-gray-300 rounded-xl bg-gray-50 hover:bg-gray-100 transition p-2">
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleLogoChange}
                            className="hidden"
                        />
                        {logoPreview ? (
                            <img
                                src={logoPreview}
                                alt="Logo Preview"
                                className="h-full object-contain"
                            />
                        ) : (
                            <span className="text-gray-400 text-sm">Click to upload</span>
                        )}
                    </label>
                </div>

                {/* Submit Button */}
                <button
                    type="submit"
                    className="w-full py-3 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 transition shadow-sm"
                >
                    Next
                </button>
            </form>
        </div>
    );
};

export default OrganizationForm;
